<p-columnFilter style="width:100%" matchMode="equals" showClearButton="false" showMatchModes="false" [field]="field"
  matchMode="equals" showMenu="false" class="filter-select">

  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
    <div class="d-block" [style]="{'min-width': '80px', 'width': '100%'}">
      <p-select [formControl]="control" class="select-input" [options]="itemsSelect"
        (onChange)="filterInput($event.value)" placeholder="Filtrar" [showClear]="false" appendTo="body" size="small">
        <ng-template let-option #item>
          <span>{{ option.label }}</span>
        </ng-template>
      </p-select>
    </div>
  </ng-template>

</p-columnFilter>